export const PiDialogStyles = {
  PiOnHoldDialog: {
    // Write jss styles if needed
  },
};
